
export const STORAGE_KEYS = {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    USER: 'user',
    PENDING_VOTE: 'pending_vote',
} as const;

export const TOKEN_REFRESH_THRESHOLD_MS = 10 * 60 * 1000; // 10 minutes

export const LOGOUT_ERROR_CODES = ['user_not_found', 'user_inactive', 'token_not_valid'];

export const AUTH_MESSAGES = {
    // Success
    login_success: '!Bienvenido/a!',
    logout_success: 'Sesion cerrada',

    // Errors
    login_error: 'No se pudo iniciar sesion. Intenta de nuevo.',
    error: 'Algo salio mal. Intenta de nuevo.',
    account_disabled: 'Tu cuenta ha sido deshabilitada.',
} as const;
